import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';


//样式文件需要单独引入
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 数字动态加载
import VueAnimateNumber from 'vue-animate-number'
Vue.use(VueAnimateNumber)

// 引入echarts
import * as echarts from 'echarts'
import 'echarts-gl';


// 点击复制
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


// 引入动画库
import "animate.css"

// 列表滚动
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

// 图片预览放大
import Viewer from 'v-viewer'  //点击图片大图预览
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({  //默认样式，可以按需求更改
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

import EZUIKit from 'ezuikit-js';

//全局导入，在main.js中导入
import videojs from "video.js";
import "video.js/dist/video-js.css";
Vue.prototype.$video = videojs;



Vue.config.productionTip = false;

Vue.prototype.baseImg = process.env.VUE_APP_API_URL
Vue.prototype.urlImg = process.env.VUE_APP_IMG_URL
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
